var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoChatBubbles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.54128 3.73401C8.19569 2.64753 10.4371 2 12.875 2C15.3129 2 17.5543 2.64753 19.2087 3.73401C20.8568 4.81634 22 6.39712 22 8.25C22 10.1029 20.8568 11.6837 19.2087 12.766C17.5543 13.8525 15.3129 14.5 12.875 14.5C10.4371 14.5 8.19569 13.8525 6.54128 12.766C4.8932 11.6837 3.75 10.1029 3.75 8.25C3.75 6.39712 4.8932 4.81634 6.54128 3.73401Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36816 17.6729C7.36816 16.4302 8.37552 15.4229 9.61816 15.4229C10.8608 15.4229 11.8682 16.4302 11.8682 17.6729C11.8682 18.9155 10.8608 19.9229 9.61816 19.9229C8.37552 19.9229 7.36816 18.9155 7.36816 17.6729Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5C5.30964 19.5 4.75 20.0596 4.75 20.75C4.75 21.4404 5.30964 22 6 22C6.69036 22 7.2501 21.4404 7.2501 20.75C7.2501 20.0596 6.69036 19.5 6 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoChatBubbles);
export default __webpack_public_path__ + "static/media/DuoChatBubbles.4ad687a4afab05f01c9c907e52f2150b.svg";
export { ForwardRef as ReactComponent };